<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3">
<h1 class="title">CAMEL PILOT SUPREME</h1>
<p class="sub_title">CAPTAIN D.V. ARMSTRONG DFC</p>
<p class="title_">ANNETTE CARSON</p>
<div class="img_container">
<img alt="image" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4fa3d032